





































import Vue from 'vue'
import Component from 'vue-class-component'
// @ts-ignore
import {HexToRGBA,RGBAtoCSS} from 'vuetify/lib/util/colorUtils'


@Component({
    name: 'SectionHeroAlt',
    provide: {
      heading: { align: 'center' },
    },
    props: {
      title: {
        type: String,
        default: ''
      },
      src: String
    }
})
export default class SectionHeroAlt extends Vue {
  
    uTitle: string = '';

    mounted(){
      this.uTitle = this.$props.title
      this.uTitle = this.uTitle.toUpperCase();
    }

    get gradient () {
      const color = `${this.$vuetify.theme.themes.light.secondary}CC`
      const overlay = RGBAtoCSS(HexToRGBA(color))

      return `to top, rgba(0,0,0,0.2), rgba(0,0,0,.3)`
    }

    get srcComputed () {
      return this.$props.src || this.$route.meta.src
    }

    get items () {
      return [
        { text: this.$t('views.home'), to: '/' },
        { text: this.$props.title },
      ]
    }


  }
